import styled from 'styled-components';
export const StyledHistoryHead = styled.div`
  background-color: ${(props) => props.theme.historyHead_BG} !important;
  color: ${(props) => props.theme.historyHead_text} !important;

  .bg-warning{
    background-color: ${(props) => props.theme.openStatus_bg} !important;
  }
`;

export const StyledHistoryBottom = styled.div`
  background-color: ${(props) => props.theme.historyBottom_BG} !important;
  color: ${(props) => props.theme.historyBottom_text} !important;
`;

export const StyledHistoryStatus = styled.div`
  .bg-warning{
    background-color: ${(props) => props.theme.openStatus_bg} !important;
  }
`;